module.exports = __webpack_public_path__ + "img/at.67c731e9.svg";